// Names players are given before they have picked one. Real words, in the
// game's own idiom — a gunner's title rather than "player_4821" — so the
// default is something a player might actually keep.
const TITLES = [
  "Bold",
  "Iron",
  "Gilded",
  "Grim",
  "Swift",
  "Stout",
  "Crimson",
  "Silent",
  "Weathered",
  "Restless",
  "Thunderous",
  "Wayward",
  "Steady",
  "Ashen",
  "Gallant",
  "Smoky",
];

const GUNNERS = [
  "Bombardier",
  "Falconet",
  "Culverin",
  "Ramrod",
  "Powderhorn",
  "Linstock",
  "Matchlock",
  "Mortar",
  "Caisson",
  "Sapper",
  "Quartermaster",
  "Cannoneer",
  "Serpentine",
  "Basilisk",
  "Gunwright",
  "Fusilier",
];

const pick = (words) => words[Math.floor(Math.random() * words.length)];

// The server has the final say on uniqueness — it hands back what it actually
// granted — so a collision here costs nothing but a suffix.
export const randomName = () => `${pick(TITLES)} ${pick(GUNNERS)}`;
